<div class="login_page ng-scope">
  <div class="login-wrapper ng-scope">
    <div id="login" class="login loginpage col-lg-offset-4 col-lg-4 col-md-offset-3 col-md-6 col-sm-offset-3 col-sm-6 col-xs-offset-2 col-xs-8">
      <h1><a href="javascript:;" title="Login Page" tabindex="-1">Fous Tele Ophthalmology - Account Management</a></h1>
      <form name="form" class="form-validation" novalidate (ngSubmit)="pwdRecoverSubmit()" #recoverForm="ngForm">
        <div class="text-danger text-center message">
          Enter your email to receive instructions on how to reset your password.
        </div>
        <div class="mTop15">
          <input type="email" name="email" id="user_email" pattern="^[\w+]+([.-]?[\w+]+)*@\w+([.-]?\w+)*(\.\w{2,3})+$"
            #email="ngModel" [(ngModel)]="emailToReset" class="input" placeholder="Email" required />
          <div *ngIf="email.errors && email.dirty" class="danger-text">
            <div *ngIf="email.errors.required">
              Email is required
            </div>
            <div *ngIf="email.errors.pattern">
              Enter valid email address.
            </div>
          </div>
        </div>
        <div class="submit">
          <button *ngIf="!emailSent" [disabled]="!recoverForm.form.valid" type="submit" class="btn btn-accent btn-block  btn-primary">Reset
          </button>
          <div *ngIf="emailSent" class="alert alert-success margin-top-15">
            <!--<strong>Success!</strong> Please check your mail to proceed further.-->
            {{message}}
          </div>
        </div>
      </form>
      <div id="g-recaptcha-token-v2" class="g-recaptcha" style="width: 100%;align-items: center;justify-content: center;"></div>
      <p id="nav">
        <a class="pull-left" title="Back to Login" href="javascript:;" [routerLink]="['/login']">Back to Login
        </a>
      </p>
    </div>
  </div>
</div>
